<template lang="pug">
.l-season

  //-選択UI
  .l-season__select

    transition(name="select")
      a.l-season__select__btn.c-seasonbtn.spring(
        @click="clickSelect(1)"
        v-show="!store.ui.state.seasonDecided"
      )
        .l-season__select__btn__ico.c-seasonbtn__ico
    
    transition(name="select")
      a.l-season__select__btn.c-seasonbtn.summer(
        @click="clickSelect(2)"
        v-show="!store.ui.state.seasonDecided"
      )
        .l-season__select__btn__ico.c-seasonbtn__ico

    transition(name="select")
      a.l-season__select__btn.c-seasonbtn.autumn(
        @click="clickSelect(3)"
        v-show="!store.ui.state.seasonDecided"
      )
        .l-season__select__btn__ico.c-seasonbtn__ico
    
    transition(name="select")
      a.l-season__select__btn.c-seasonbtn.winter(
        @click="clickSelect(4)"
        v-show="!store.ui.state.seasonDecided"
      )
        .l-season__select__btn__ico.c-seasonbtn__ico

  //-決定UI
  .l-season__deside

    transition(name="deside")
      a.l-season__deside__btn.c-seasonbtn.spring(
        @click="clickDeside()"
        :class="{active:store.ui.state.seasonDecided}"
        v-show="store.ui.state.seasonDecided && store.ui.state.season == 1"
      )
        .l-season__deside__btn__ico.c-seasonbtn__ico
    
    transition(name="deside")
      a.l-season__deside__btn.c-seasonbtn.summer(
        @click="clickDeside()"
        :class="{active:store.ui.state.seasonDecided}"
        v-show="store.ui.state.seasonDecided && store.ui.state.season == 2"
      )
        .l-season__deside__btn__ico.c-seasonbtn__ico
    
    transition(name="deside")
      a.l-season__deside__btn.c-seasonbtn.autumn(
        @click="clickDeside()"
        :class="{active:store.ui.state.seasonDecided}"
        v-show="store.ui.state.seasonDecided && store.ui.state.season == 3"
      )
        .l-season__deside__btn__ico.c-seasonbtn__ico
    
    transition(name="deside")
      a.l-season__deside__btn.c-seasonbtn.winter(
        @click="clickDeside()"
        :class="{active:store.ui.state.seasonDecided}"
        v-show="store.ui.state.seasonDecided && store.ui.state.season == 4"
      )
        .l-season__deside__btn__ico.c-seasonbtn__ico

</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.c-seasonbtn
  background-color #e6e6e6
  border-radius 50%
  display block
  position relative
  cursor pointer
  no_highlight()
  +pc()
    wh(72px)
    box-shadow 0 4px 6px rgba(150,150,150,0.45)
    transition transform 400ms $easeOutBack
    &:hover
      transform scale(1.1)
  +sp()
    wh(82px)
    box-shadow 0 4px 6px rgba(150,150,150,0.45)
  &:after
    content ""
    posc()
    background-color #FFF
    border-radius 50%
  
  
  &__ico
    posc(10)
    wh(66%)
    background-size cover
    ^[0].spring &
      background-image url('~@/assets/images/ui-season-ico-spring.svg')
    ^[0].summer &
      background-image url('~@/assets/images/ui-season-ico-summer.svg')
    ^[0].autumn &
      background-image url('~@/assets/images/ui-season-ico-autumn.svg')
    ^[0].winter &
      background-image url('~@/assets/images/ui-season-ico-winter.svg')

.l-season
  &__select
    +pc()
      posrb(26px,115px,20)
    +sp()
      posrb(33px,188px,20)
    &__btn
      posrb()
      +pc()
        wh(56px)
        &:after
          wh(48px)

        &:nth-child(1)
          bottom 210px
        &:nth-child(2)
          bottom 140px
        &:nth-child(3)
          bottom 70px
        &:nth-child(4)
          bottom 0px
      +sp()
        wh(82px)
        &:after
          wh(74px)

        &:nth-child(1)
          bottom 300px
        &:nth-child(2)
          bottom 200px
        &:nth-child(3)
          bottom 100px
        &:nth-child(4)
          bottom 0px

  &__deside
    +pc()
      posrb(18px,112px,20)
    +sp()
      posrb(18px,188px,20)
    &__btn
      posrb()
      +pc()
        wh(70px)
        &:after
          wh(64px)
      +sp()
        wh(116px)
        &:after
          wh(108px)


/** transition */
.select-enter-active
  transition all 750ms $easeOutExpo 400ms
.select-leave-active
  transition all 750ms $easeOutExpo

.select-enter-from,
.select-leave-to
  right -130px !important
  transform rotate(135deg)


.select-enter-to,
.select-leave-from
  right 0px !important
  transform rotate(0deg)


/** transition */
.deside-enter-active
  transition all 750ms $easeOutExpo 400ms
.deside-leave-active
  transition all 750ms $easeOutExpo

.deside-enter-from,
.deside-leave-to
  right -150px !important
  transform rotate(135deg)


.deside-enter-to
.deside-leave-from
  right 0px !important
  transform rotate(0deg)




</style>


<script>
import { defineComponent, computed, reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'


export default defineComponent({
  name:'Season',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const clickSelect = (season) =>{
      store.ui.state.seasonDecided = true
      store.ui.state.season = season
      store.ui.state.hotoke = false
    }
    const clickDeside = () =>{
      store.ui.state.seasonDecided = false
    }

    return{
      clickSelect,
      clickDeside,
      store
    }
  }
})
</script>
